const PAGES = new Set(['classifications.html', 'standalone.html', 'new-deal.html', 'personal-settings.html', 'document.html']);
const SELECTORS: Record<string, RegExp> = {
  instrument: /^[A-Za-z0-9:_-]{1,200}$/,
  surface: /^(overview|facts|structure)$/,
  view: /^(contract|classification)$/,
  path_id: /^[A-Za-z0-9_-]{1,160}$/,
  investigation: /^[A-Za-z0-9_-]{1,160}$/,
  document: /^[A-Za-z0-9:_-]{1,200}$/,
  editor: /^(1|true|fields|classification)$/,
  question: /^[A-Za-z0-9:._-]{1,200}$/,
};

/** Selection only. Tokens, tenant/user IDs and unknown query fields never cross the shell boundary. */
export function classificationSelection(search: string): string {
  const source = new URLSearchParams(search);
  const target = new URLSearchParams();
  const page = source.get('page');
  if (page && PAGES.has(page) && page !== 'classifications.html') target.set('page', page);
  for (const [key, pattern] of Object.entries(SELECTORS)) {
    const value = source.get(key);
    if (value && pattern.test(value)) target.set(key, value);
  }
  // document.mjs renders/targets exact passage-<segment_id> element IDs.
  const passage = source.get('passage');
  if (page === 'document.html' && passage && /^passage-[A-Za-z0-9:._-]{1,240}$/.test(passage)) target.set('passage', passage);
  const back = source.get('return_to');
  if (page === 'personal-settings.html' && back && /^\/(?:classification\/ui\/)?standalone\.html\?/.test(back)) {
    const url = new URL(back, 'https://classification.invalid');
    const instrument = url.searchParams.get('instrument');
    if (url.origin === 'https://classification.invalid' && ['/standalone.html', '/classification/ui/standalone.html'].includes(url.pathname)
      && instrument && SELECTORS.instrument.test(instrument)) {
      const view = url.searchParams.get('view');
      const query = new URLSearchParams({ live: '1', view: view && SELECTORS.view.test(view) ? view : 'contract', instrument });
      const surface = url.searchParams.get('surface');
      if (surface && SELECTORS.surface.test(surface)) query.set('surface', surface);
      target.set('return_to', `/classification/ui/standalone.html?${query}`);
    }
  }
  return target.toString();
}

export function classificationDocument(base: string, search: string): URL {
  const selected = new URLSearchParams(classificationSelection(search));
  const page = selected.get('page') || 'classifications.html';
  selected.delete('page');
  const passage = selected.get('passage');
  selected.delete('passage');
  const url = new URL(`${base.replace(/\/+$/, '')}/classification/ui/${page}`);
  if (page === 'standalone.html' || page === 'new-deal.html') selected.set('live', '1');
  url.search = selected.toString();
  if (page === 'document.html' && passage) url.hash = passage;
  return url;
}

export function selectionFromDocument(href: string, base: string): string | null {
  let url: URL;
  try { url = new URL(href); } catch { return null; }
  const root = new URL(`${base.replace(/\/+$/, '')}/classification/ui/`);
  if (url.origin !== root.origin || !url.pathname.startsWith(root.pathname)) return null;
  const page = url.pathname.slice(root.pathname.length);
  if (!PAGES.has(page)) return null;
  const params = new URLSearchParams(url.search);
  params.set('page', page);
  if (page === 'document.html' && url.hash) {
    try { params.set('passage', decodeURIComponent(url.hash.slice(1))); } catch { return null; }
  }
  return classificationSelection(params.toString());
}
